// frontend/packages/business-console/src/components/build-interview/ExampleChips.jsx
//
// Tap-to-add example chips for the freeform interview steps (Website Builder
// Redesign, Phase 1). Tapping a chip inserts a labelled scaffold into the answer
// box so nobody faces a blank field. Pure front-end; chip sets come from
// stepMeta. Colors via useTokens (auto light/dark).

import React from 'react';
import { Box, Typography } from '@mui/material';
import useTokens from '../primitives/useTokens';

export default function ExampleChips({ chips = [], onInsert, disabled = false }) {
  const t = useTokens();
  if (!chips.length) return null;
  return (
    <Box>
      <Typography sx={{ fontSize: 11.5, color: t.faint, mb: 0.75 }}>
        Tap to add, or just type below
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
        {chips.map((c) => (
          <Box
            component="button"
            type="button"
            key={c.label}
            disabled={disabled}
            onClick={() => onInsert && onInsert(c.insert)}
            sx={{
              font: 'inherit',
              fontSize: 12,
              fontWeight: 600,
              color: t.blue,
              background: t.blueBg,
              border: `1px solid ${t.blueBorder}`,
              borderRadius: '999px',
              padding: '6px 12px',
              cursor: disabled ? 'default' : 'pointer',
              opacity: disabled ? 0.6 : 1,
              transition: 'all .15s ease',
              '&:hover': disabled
                ? undefined
                : { background: t.blue, color: '#fff', borderColor: t.blue },
            }}
          >
            {c.label}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
